interface PromoEvent {
  promoId: string;
  promoCode: string;
  promoTitle: string;
  storeName: string;
  storeId: string;
  discount: string;
  timestamp: string;
}

interface SearchEvent {
  query: string;
  resultsCount: number;
  timestamp: string;
}

interface TelegramClickEvent {
  storeName: string;
  storeSlug: string;
  promoCode: string;
  utmCampaign: string;
  timestamp: string;
  referrer: string;
}

interface PromoStats {
  copies: PromoEvent[];
  reveals: PromoEvent[];
  searches: SearchEvent[];
  telegramClicks: TelegramClickEvent[];
}

const STATS_KEY = 'promo_statistics';

function getStats(): PromoStats {
  const saved = localStorage.getItem(STATS_KEY);
  if (saved) {
    const parsed = JSON.parse(saved);
    if (!parsed.telegramClicks) parsed.telegramClicks = [];
    return parsed;
  }
  return { copies: [], reveals: [], searches: [], telegramClicks: [] };
}

function saveStats(stats: PromoStats) {
  localStorage.setItem(STATS_KEY, JSON.stringify(stats));
}

export function trackPromoReveal(data: {
  promoId: string;
  promoCode: string;
  promoTitle: string;
  storeName: string;
  storeId: string;
  discount: string;
}) {
  const stats = getStats();
  stats.reveals.push({
    ...data,
    timestamp: new Date().toISOString(),
  });
  saveStats(stats);
}

export function trackPromoCopy(data: {
  promoId: string;
  promoCode: string;
  promoTitle: string;
  storeName: string;
  storeId: string;
  discount: string;
}) {
  const stats = getStats();
  stats.copies.push({
    ...data,
    timestamp: new Date().toISOString(),
  });
  saveStats(stats);
}

export function trackSearch(query: string, resultsCount: number) {
  const stats = getStats();
  stats.searches.push({
    query,
    resultsCount,
    timestamp: new Date().toISOString(),
  });
  saveStats(stats);
}

export function trackTelegramClick(data: {
  storeName: string;
  storeSlug: string;
  promoCode: string;
  utmCampaign: string;
  referrer: string;
}) {
  const stats = getStats();
  stats.telegramClicks.push({
    ...data,
    timestamp: new Date().toISOString(),
  });
  saveStats(stats);
}

export function getPromoStatistics(): PromoStats {
  return getStats();
}

export function clearStatistics() {
  localStorage.removeItem(STATS_KEY);
}
